import React, { useState } from "react";
import { Button, Label, TextInput } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "../style/Login.css";
import axios from "axios";

const AgentLogin = () => {
  const navigate = useNavigate();
  const [Input, setInput] = useState({ username: "", password: "" });
  const baseURL = process.env.REACT_APP_BASE_URL;

  const onChangeValue = (e) => {
    setInput({ ...Input, [e.target.name]: e.target.value });
  };

  const loginSubmit = async (e) => {
    e.preventDefault();

    try {
      sessionStorage.clear();
      const response = await axios.post(`${baseURL}/agent-login`, {
        username: Input.username,
        password: Input.password,
      });

      if (
        response.status === 200 &&
        response.data.message === "Login successful"
      ) {
        const { access_token, admin_id, status,username } = response.data;

        sessionStorage.setItem("access_token", access_token);
        sessionStorage.setItem("agent_id", admin_id);
        sessionStorage.setItem("status", status);
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("role", "agent");

        Swal.fire({
          icon: "success",
          text: "Agent login successful!",
          timer: 2000,
          showConfirmButton: false,
        });

        navigate("/AgentDashboard");
      } else {
        Swal.fire({
          icon: "error",
          text: "Invalid username or password",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Agent Login error:", error);
      Swal.fire({
        icon: "error",
        text: "An error occurred. Please try again later.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className="login-container">
      <div className="contact-box">
        <div className="p-6 login-card bg-white">
          <h2 className="text-lg font-bold text-center mb-4 text-blue-700">
            Collection Agent Login
          </h2>
          <form className="flex flex-col gap-4" onSubmit={loginSubmit}>
            <div>
              <Label htmlFor="username" value="Username" />
              <TextInput
                name="username"
                id="username"
                type="text"
                required
                onChange={onChangeValue}
              />
            </div>
            <div>
              <Label htmlFor="password" value="Password" />
              <TextInput
                name="password"
                id="password"
                type="password"
                required
                onChange={onChangeValue}
              />
            </div>

            <div className="flex justify-center gap-4">
              <Button type="submit" color="purple">
                Login
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgentLogin;
